import ReactHotkeys from 'react-hot-keys';
import ArrowLeftRegularIcon from '../../../../../../icons/regular/arrow-left';
import ElementsConfigureTable from '../ElementsConfigureTable';
import RightPopUp from '../../../../../common/RightPopUp';
import { GlobalStateV1 } from '../../../../../../store/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { getGenieSetting } from '../../../../../../store/selectors/session';
import { GeniePadElementsSettingItem } from '../../../../../../api/pushGenie';
import { useState } from 'react';
import { settingsIcon } from '../../../../../common/Icons';
import { AnimatePresence } from 'framer-motion';
import { upsertGenieSetting } from '../../../../../../store/actions/session';

const ConfigureInjectionTable = (): JSX.Element => {
    const dispatch = useDispatch();
    const injectionTableConfig = useSelector((state) =>
        getGenieSetting(state as GlobalStateV1, 'injectionTableConfig'),
    ) as GeniePadElementsSettingItem[];

    const [currentConfig, setCurrentConfig] = useState<GeniePadElementsSettingItem[]>(
        injectionTableConfig,
    );
    const [showConfig, setShowConfig] = useState<boolean>(false);

    const handleClose = () => {
        setShowConfig(false);
    };

    const onSave = () => {
        dispatch(upsertGenieSetting({ injectionTableConfig: currentConfig }));
        handleClose();
    };

    const handleUpdate = (config: GeniePadElementsSettingItem[]) => {
        setCurrentConfig(config);
    };
    return (
        <>
            <AnimatePresence>
                {showConfig ? (
                    <ReactHotkeys keyName="esc" onKeyDown={handleClose}>
                        <RightPopUp closeMe={handleClose} width={'50%'} minWidth={'480px'}>
                            <div className="bg-darwin-neutral-50 flex flex-col h-full space-between">
                                <div className="flex items-center space-x-16 p-16 cursor-pointer">
                                    <div
                                        onClick={handleClose}
                                        className="flex items-center justify-center w-16 h-16"
                                    >
                                        <ArrowLeftRegularIcon className="w-16 h-16" />
                                    </div>
                                    <p className="text-darwin-neutral-1000 heading-2 bold">
                                        Configure Injections Table
                                    </p>
                                </div>
                                <div className="w-full pl-8 border-b border-neutral-8 select-none"></div>
                                <div className="p-16 flex flex-col flex-1 space-y-16 h-full overflow-auto">
                                    <div className="p-16 rounded-8 bg-white space-y-8">
                                        <p className="body-1 bold text-darwin-neutral-1000">
                                            Order of fields in “Injections Table”
                                        </p>
                                        <ElementsConfigureTable
                                            config={currentConfig}
                                            onUpdate={handleUpdate}
                                        />
                                    </div>
                                </div>
                                <div className="flex items-center justify-between px-16 py-8 space-x-8 border-t border-neutral-7">
                                    <div>
                                        <button
                                            onClick={handleClose}
                                            className="neutral-btn btn--small px-16 py-8"
                                        >
                                            <span className="w-full text-center">Cancel</span>
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            onClick={onSave}
                                            className="primary-btn  px-12 py-8 btn btn--small space-x-8"
                                        >
                                            <span className="w-full text-center">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </RightPopUp>
                    </ReactHotkeys>
                ) : null}
            </AnimatePresence>
            <span
                onClick={() => setShowConfig(true)}
                className="flex justify-center items-center bg-darwin-neutral-50 text-darwin-neutral-800 h-24 w-24 rounded-full cursor-pointer"
            >
                {settingsIcon('fill-neutral-3')}
            </span>
        </>
    );
};

export default ConfigureInjectionTable;
